import { defineMessages } from "react-intl";

const messages = defineMessages({
  assignee: {
    id: "component.activityOwnerAssignee.assignee",
    defaultMessage: "Assignee:",
    description: "Activity owner and assignee rows: assignee label",
  },
  owner: {
    id: "component.activityOwnerAssignee.owner",
    defaultMessage: "Owner:",
    description: "Activity owner and assignee rows: owner label",
  },
});

export default messages;
